
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C114.838 0 0 114.838 0 256c0 141.151 114.838 256 256 256 141.151 0 256-114.849 256-256C512 114.838 397.151 0 256 0zm0 494.639C124.423 494.639 17.361 387.578 17.361 256 17.361 124.412 124.423 17.361 256 17.361c131.588 0 238.638 107.051 238.638 238.639.001 131.578-107.049 238.639-238.638 238.639zm-25.997-333.346a8.69 8.69 0 00-12.286 0c-3.38 3.38-3.38 8.896 0 12.286l78.656 78.736-78.656 78.736c-3.391 3.39-3.391 8.906 0 12.286a8.64 8.64 0 006.138 2.543 8.648 8.648 0 006.148-2.555l84.772-84.874a8.67 8.67 0 000-12.285l-84.772-84.873z"}})])
          )
        }
      }
    